import { useEffect } from "react";
import { useAuth } from "@/context/Auth";
import { Loader2 } from "lucide-react";
import AppLayout from "@/components/layout/AppLayout";
import Tier1Dashboard from "@/pages/pm/Tier1Dashboard";
import Tier2Dashboard from "@/pages/pm/Tier2Dashboard";

export const PM_ROUTER_BUILD_VERSION = "tier-split-2026-04-30";

/**
 * PortfolioManagerRouter
 *
 * Selects the correct PM dashboard based on the user's tier.
 * Tier 1 and Tier 2 dashboards are fully independent — they share no
 * rendering logic, no data-fetching logic, and no RPC usage. Only UI
 * primitives (buttons, cards, tables) and small utilities are shared
 * via the design system / lib helpers.
 *
 *  - tier_1 → Tier1Dashboard (MSP, lightweight, 3-client limit)
 *  - tier_2 / tier_3 / default → Tier2Dashboard (full PM experience)
 */
export default function PortfolioManagerDashboard() {
  const { tier, loading } = useAuth();

  useEffect(() => {
    console.log("PM_ROUTER_BUILD_VERSION=" + PM_ROUTER_BUILD_VERSION);
    console.log("Rendering PortfolioManagerRouter", { tier, loading });
  }, [tier, loading]);

  if (loading) {
    return (
      <AppLayout title="Portfolio Manager">
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
      </AppLayout>
    );
  }

  if (tier === "tier_1") {
    return (
      <>
        <Tier1Dashboard />
        <div className="fixed bottom-1 right-2 text-[10px] text-muted-foreground/40 pointer-events-none select-none z-50">
          build: {PM_ROUTER_BUILD_VERSION}
        </div>
      </>
    );
  }

  return (
    <>
      <Tier2Dashboard />
      <div className="fixed bottom-1 right-2 text-[10px] text-muted-foreground/40 pointer-events-none select-none z-50">
        build: {PM_ROUTER_BUILD_VERSION}
      </div>
    </>
  );
}
